import React, { useEffect, useState } from 'react';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
import { goToCheckout } from '../constants/links';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'pro'>('pro');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="bg-violet text-white py-12" data-id="element-133">
      <div className="max-w-md mx-auto px-4" data-id="element-134">
        {/* Big Timer */}
        <div className="text-center mb-10" data-id="element-135">
          <p className="text-sm font-bold mb-3 uppercase tracking-wider text-white/90" data-id="element-136">
            Esta oferta termina en
          </p>
          <div className="flex justify-center gap-3" data-id="element-137">
            {[{
            value: timeLeft.hours,
            label: 'HORAS'
          }, {
            value: timeLeft.minutes,
            label: 'MIN'
          }, {
            value: timeLeft.seconds,
            label: 'SEG'
          }].map((item, idx) => <div key={idx} className="flex flex-col items-center" data-id="element-138">
                <div className="bg-navy-light text-white text-4xl font-bold rounded-xl w-16 h-16 flex items-center justify-center shadow-lg border border-white/10" data-id="element-139">
                  {formatTime(item.value)}
                </div>
                <span className="text-[10px] mt-2 font-bold text-white/70" data-id="element-140">
                  {item.label}
                </span>
              </div>)}
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-141">
          <h2 className="text-3xl font-extrabold mb-2" data-id="element-142">
            ELEGÍ TU FLAUTA MASTER CLASS
          </h2>
          <p className="text-turquoise text-sm font-medium" data-id="element-143">
            Ambas opciones incluyen los 6 tomos y los 4 bonos base
          </p>
        </div>

        {/* Plan Selector */}
        <div className="space-y-4 mb-8" data-id="element-144">
          {/* Base Plan */}
          <label className={`block relative p-5 rounded-2xl cursor-pointer transition-all ${selectedPlan === 'base' ? 'bg-white/10 border-2 border-turquoise' : 'bg-navy-light/50 border-2 border-transparent hover:bg-navy-light/70'}`} data-id="element-145">
            <div className="flex items-start gap-4" data-id="element-146">
              <div className="mt-1 shrink-0" data-id="element-147">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'base' ? 'border-turquoise' : 'border-white/50'}`} data-id="element-148">
                  {selectedPlan === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-turquoise" data-id="element-149" />}
                </div>
                <input type="radio" name="plan" value="base" checked={selectedPlan === 'base'} onChange={() => setSelectedPlan('base')} className="hidden" data-id="element-150" />
              </div>
              <div className="flex-1" data-id="element-151">
                <h3 className="font-bold text-lg mb-1 flex items-center gap-2" data-id="element-152">
                  <span data-id="element-153">🎵</span> SISTEMA BASE
                </h3>
                <p className="text-sm text-white/80 mb-3" data-id="element-154">
                  6 tomos + 4 bonos estratégicos
                </p>
                <div className="flex items-baseline gap-2" data-id="element-155">
                  <span className="text-sm line-through text-white/50" data-id="element-156">
                    $34.990
                  </span>
                  <span className="text-2xl font-extrabold" data-id="element-157">$18.990</span>
                </div>
              </div>
            </div>
          </label>

          {/* Pro Plan */}
          <label className={`block relative p-5 rounded-2xl cursor-pointer transition-all ${selectedPlan === 'pro' ? 'bg-white/10 border-2 border-turquoise' : 'bg-navy-light/50 border-2 border-transparent hover:bg-navy-light/70'}`} data-id="element-158">
            {/* Badges */}
            <div className="absolute -top-3 right-4 flex gap-2" data-id="element-159">
              <span className="bg-green-600 text-white text-[10px] font-bold px-2 py-1 rounded-full shadow-sm" data-id="element-160">
                AHORRÁS $32.000
              </span>
              <span className="bg-turquoise text-white text-[10px] font-bold px-2 py-1 rounded-full shadow-sm" data-id="element-161">
                ⭐ MÁS ELEGIDO
              </span>
            </div>

            <div className="flex items-start gap-4" data-id="element-162">
              <div className="mt-1 shrink-0" data-id="element-163">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'pro' ? 'border-turquoise' : 'border-white/50'}`} data-id="element-164">
                  {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-turquoise" data-id="element-165" />}
                </div>
                <input type="radio" name="plan" value="pro" checked={selectedPlan === 'pro'} onChange={() => setSelectedPlan('pro')} className="hidden" data-id="element-166" />
              </div>
              <div className="flex-1" data-id="element-167">
                <h3 className="font-bold text-lg mb-1 flex items-center gap-2" data-id="element-168">
                  <span data-id="element-169">🚀</span> PLAN PRO
                </h3>
                <p className="text-sm text-white/80 mb-3" data-id="element-170">
                  6 tomos + 4 bonos + 3 herramientas PRO para el aula
                </p>
                <div className="flex items-baseline gap-2" data-id="element-171">
                  <span className="text-sm line-through text-white/50" data-id="element-172">
                    $54.990
                  </span>
                  <span className="text-2xl font-extrabold" data-id="element-173">$27.990</span>
                </div>
              </div>
            </div>
          </label>
        </div>

        {/* CTA Button */}
        <div className="text-center" data-id="element-174">
          <button onClick={() => goToCheckout(selectedPlan)} className="w-full h-[56px] bg-turquoise hover:bg-turquoise/90 text-white font-bold text-lg rounded-xl transition-colors shadow-lg shadow-turquoise/20 mb-3" data-id="element-175">
            SÍ, QUIERO EL {selectedPlan === 'pro' ? 'PLAN PRO' : 'SISTEMA BASE'}{' '}
            →
          </button>
          <p className="text-xs text-white/80" data-id="element-176">
            La opción más elegida por docentes que quieren dar clase sin
            improvisar
          </p>
        </div>

        {/* Trust Bar */}
        <div className="flex justify-center gap-4 mt-8 text-xs font-medium text-white/90" data-id="element-177">
          <div className="flex items-center gap-1" data-id="element-178">
            <Lock className="w-3.5 h-3.5" data-id="element-179" />
            <span data-id="element-180">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-181">
            <Zap className="w-3.5 h-3.5" data-id="element-182" />
            <span data-id="element-183">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-184">
            <ShieldCheck className="w-3.5 h-3.5" data-id="element-185" />
            <span data-id="element-186">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}